// src/frontend/data/books/BlockchainFundamentals/contents.js

 const BOOK_BITCOIN_MASTER_COURSE_CONTENTS = [
  { id: 1,  title: "Bitcoin", type: "external", component: "cap1" },
  { id: 2,  title: "Ethereum", type: "external", component: "cap2" },
  { id: 3,  title: "Tether", type: "external", component: "cap3" },
  { id: 4,  title: "Solana", type: "external", component: "cap4" },
  { id: 5,  title: "Polygon", type: "external", component: "cap5" },
  { id: 6,  title: "Cardano", type: "external", component: "cap6" },
  { id: 7,  title: "Dai", type: "external", component: "cap7" },
  { id: 8,  title: "IOTA", type: "external", component: "cap8" },
  { id: 9,  title: "Monero", type: "external", component: "cap9" },
  { id: 10,  title: "Polkadot", type: "external", component: "cap10" },
  { id: 11,  title: "DOGE", type: "external", component: "cap11" },
  { id: 12,  title: "Hashgraph", type: "external", component: "cap12" },
  { id: 13,  title: "Bitcoin, Altcoins, Stablecoins, Memecoins y Native Coins", type: "external", component: "cap13" },
 
];

export default  BOOK_BITCOIN_MASTER_COURSE_CONTENTS